// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IncentiveTimeline.css */
.timeline-container {
  /* max-width: 600px; */
  margin: 2rem auto;
  font-family: 'Poppins', sans-serif;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0,0,0,0.1);
  padding: 2rem;
  color: #333;
}

.timeline-header {
  font-weight: 600;
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
}

.timeline {
  position: relative;
  margin-left: 20px;
  /* padding-left: 20px;
  border-left: 3px solid #6c63ff; */
}

.timeline-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
  position: relative;
}

.timeline-dot {
  position: absolute;
  left: 50%;
  top: 88%;
  height: 16px;
  width: 16px;
  /* background: #6c63ff; */
  border-radius: 50%;
box-shadow:
  0 0 15px rgba(255, 255, 255, 1),
  0 0 30px rgba(255, 255, 255, 0.9),
  0 0 60px rgba(255, 255, 255, 0.8);


  z-index: 100;
}
.timeline-line {
  position: absolute;
  left: 50.60%;
  top: 100%;
  height: 2rem;
  width: 4px;
  /* background: #6c63ff; */
  /* border-radius: 50%; */
  /* box-shadow: 0 0 8px rgba(108, 99, 255, 0.6); */
}

.timeline-content {
  background: #f5f6ff;
  padding: 1rem 1.5rem;
  border-radius: 8px;
  box-shadow: 0 1px 5px rgba(108, 99, 255, 0.2);
  flex-grow: 1;
  transition: transform 0.3s ease;
}

.timeline-content:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(108, 99, 255, 0.4);
}

.item-title {
  font-size: 1.25rem;
  margin: 0;
  font-weight: 700;
  color: #3b3f5c;
}

.item-date {
  margin-top: 0.3rem;
  font-size: 0.95rem;
  color: #7a7a9d;
  font-weight: 500;
}

/* Remove margin after last item */
.timeline-item:last-child {
  margin-bottom: 0;
}

.download-btn {
  background-color: #fff;
  color: #f26623; /* orange text or #ff9800 for brighter orange */
  border: 2px solid #f26623;
  padding: 12px 28px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.25s, color 0.25s;
}

.download-btn:hover {
  background-color: #f26623;
  color: #fff;
  box-shadow: 0 4px 18px rgba(242,102,35,0.12);
}
`, "",{"version":3,"sources":["webpack://./src/styles/initatives.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB;mCACiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;;mCAGmC;;;EAGjC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,6CAA6C;EAC7C,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc,EAAE,+CAA+C;EAC/D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,4CAA4C;AAC9C","sourcesContent":["/* IncentiveTimeline.css */\n.timeline-container {\n  /* max-width: 600px; */\n  margin: 2rem auto;\n  font-family: 'Poppins', sans-serif;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 0 15px rgba(0,0,0,0.1);\n  padding: 2rem;\n  color: #333;\n}\n\n.timeline-header {\n  font-weight: 600;\n  font-size: 1.8rem;\n  color: #2c3e50;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.timeline {\n  position: relative;\n  margin-left: 20px;\n  /* padding-left: 20px;\n  border-left: 3px solid #6c63ff; */\n}\n\n.timeline-item {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.timeline-dot {\n  position: absolute;\n  left: 50%;\n  top: 88%;\n  height: 16px;\n  width: 16px;\n  /* background: #6c63ff; */\n  border-radius: 50%;\nbox-shadow:\n  0 0 15px rgba(255, 255, 255, 1),\n  0 0 30px rgba(255, 255, 255, 0.9),\n  0 0 60px rgba(255, 255, 255, 0.8);\n\n\n  z-index: 100;\n}\n.timeline-line {\n  position: absolute;\n  left: 50.60%;\n  top: 100%;\n  height: 2rem;\n  width: 4px;\n  /* background: #6c63ff; */\n  /* border-radius: 50%; */\n  /* box-shadow: 0 0 8px rgba(108, 99, 255, 0.6); */\n}\n\n.timeline-content {\n  background: #f5f6ff;\n  padding: 1rem 1.5rem;\n  border-radius: 8px;\n  box-shadow: 0 1px 5px rgba(108, 99, 255, 0.2);\n  flex-grow: 1;\n  transition: transform 0.3s ease;\n}\n\n.timeline-content:hover {\n  transform: scale(1.05);\n  box-shadow: 0 4px 15px rgba(108, 99, 255, 0.4);\n}\n\n.item-title {\n  font-size: 1.25rem;\n  margin: 0;\n  font-weight: 700;\n  color: #3b3f5c;\n}\n\n.item-date {\n  margin-top: 0.3rem;\n  font-size: 0.95rem;\n  color: #7a7a9d;\n  font-weight: 500;\n}\n\n/* Remove margin after last item */\n.timeline-item:last-child {\n  margin-bottom: 0;\n}\n\n.download-btn {\n  background-color: #fff;\n  color: #f26623; /* orange text or #ff9800 for brighter orange */\n  border: 2px solid #f26623;\n  padding: 12px 28px;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.25s, color 0.25s;\n}\n\n.download-btn:hover {\n  background-color: #f26623;\n  color: #fff;\n  box-shadow: 0 4px 18px rgba(242,102,35,0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
